var exports = {
  "Qs": "UserVideoTab.module__content___TjNXQ3",
  "zN": "UserVideoTab.module__controlGroup___TjNXQ3",
  "ZT": "UserVideoTab.module__deviceNotice___TjNXQ3",
  "ei": "UserVideoTab.module__deviceNoticeText___TjNXQ3",
  "dv": "UserVideoTab.module__deviceNoticeTitle___TjNXQ3",
  "H6": "UserVideoTab.module__deviceNoticeDescription___TjNXQ3",
  "IR": "UserVideoTab.module__premiumCard___TjNXQ3",
  "LS": "UserVideoTab.module__premiumHeader___TjNXQ3",
  "PC": "UserVideoTab.module__premiumIcon___TjNXQ3",
  "CA": "UserVideoTab.module__premiumTitle___TjNXQ3",
  "SM": "UserVideoTab.module__premiumDescription___TjNXQ3",
  "eQ": "UserVideoTab.module__frameRateNote___TjNXQ3",
  "xe": "UserVideoTab.module__frameRateIcon___TjNXQ3",
  "hP": "UserVideoTab.module__actionButton___TjNXQ3",
  "a9": "UserVideoTab.module__cameraControlGroup___TjNXQ3",
  "$l": "UserVideoTab.module__actionRow___TjNXQ3",
  "ZJ": "UserVideoTab.module__actionLabel___TjNXQ3",
};

module.exports = exports;
